const footer_en={
        "rights":"LEVTY. All rights reserved.",
        "visit":[
            {
                "title":"Access",
                "plans":"Plans"
            },
            {
                "title":"Social medias",
                "description":"Follow LEVTY on social medias"
            }
        ],
        "privacyPolicy":"Privacy policy"
}  
export default footer_en